export default __webpack_public_path__ + "static/media/dino_standup.9cf09094.png";